import * as Sentry from '@sentry/browser';

// axios
window._axios = require('axios').default;
window._axios.defaults.headers.common['X-CSRF-TOKEN'] = window.Laravel.csrfToken;
window._axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

_axios.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error && error.response && error.response.data && error.response.data.errors) {
        let responseData = error.response.data;

        if(responseData.dialog && responseData.dialog.type && responseData.dialog.type === "alert") {
            Vue.prototype.$alert(responseData.dialog.html, responseData.dialog.title, {
                dangerouslyUseHTMLString: true
            });
        } else {
            _.each(responseData.errors, (e) => {
                Vue.prototype.$message({
                    message: e,
                    type: `error`,
                });
            });
        }      
    }
    else {
        Vue.prototype.$message({
            message: 'An unexpected error has occured.',
            type: `error`,
        });
    }

    if (error && error.response) {
        Sentry.setContext("response", error.response);
        Sentry.addBreadcrumb({
            category: "response",
            data: error.response,
            level: Sentry.Severity.Log,
        });
    } 
    else if (error && error.request) {
        Sentry.setContext("request", error.request)
        Sentry.addBreadcrumb({
            category: "request",
            data: error.request,
            level: Sentry.Severity.Log,
        });
    }
    else if (error && error.message) {
        Sentry.setContext("error", error.message)
        Sentry.addBreadcrumb({
            category: "error",
            data: error.message,
            level: Sentry.Severity.Log,
        });
    }
    if (error && error.config) {
        Sentry.setContext("config", error.config)
    }

    return Promise.reject(error);
});
_axios.defaults.validateStatus = function (status) {
    return status >= 200 && status < 300;
};

require('./axiosWithSentry').default;
